const dataCables = [
	// MAREA
	{
		geometry: {
			type: 'MultiLineString',
			coordinates: [
				[[-3.25, 43.38], [-16.6, 46.6], [-31.2, 42.5], [-42.6, 38.9], [-58.9, 36.1], [-75.977, 36.853]],
				[[-2.935, 43.261], [-3.0, 43.38],  [-3.25, 43.38]],
				[[-2.935, 43.261], [-3.2, 43.261], [-3.25, 43.38]]
			]
		},
		name: 'MAREA',
		codename: 'MAREA',
		long: 6605,
		lon: -42,
		lat: 36,
		zoom: 1.5,
		ls: [63, 82]
	},

	// BRUSA
	{
		geometry: {
			type: 'MultiLineString',
			coordinates: [
				[
					[-75.977, 36.852],
					[-74.5, 30.9],
					[-65.753, 24.1],
					[-43, 13.6],
					[-30.042, 3.723],
					[-28.9, -13.24],
					[-32.8, -20],
					[-38.7, -23.7],
					[-43.066, -22.918]
				],
				[[-65.753, 24.1], [-66.413, 18.22]],
				[[-30.042, 3.723], [-38.521, -3.73]]
			]
		},
		name: 'BRUSA',
		codename: 'BRUSA',
		long: 11000,
		lon: -50,
		lat: 9,
		zoom: 1.5,
		ls: [82, 8, 9, 54]
	},

	// SAM-1
	{
		geometry: {
			type: 'MultiLineString',
			coordinates: [
				// Boca Raton - Pto Barrios, Guatemala -  Pto San Jose
				[
					[-80.083, 26.359],
					[-79.8, 23.7],
					[-85.15, 23.75],
					[-84.3, 19.85],
					[-88.435, 15.836]
				],

				// Pto San Jose - Lurin

				[[-90.819, 13.924], [-86.532, 6.105], [-85.522, -2.666], [-83.061, -9.653], [-76.878, -12.277]],

				// Lima - Lurin X2
				[[-77.042, -11.046], [-77.3, -11.6], [-76.878, -12.277]],
				[[-77.042, -11.046], [-76.7, -11.65], [-76.878, -12.277]],

				//
				[[-71.62, -33.046], [-73.504, -25.659], [-70.321, -18.478], [-74.88, -18.414], [-76.877, -12.276]],
				[[-80.822, -1.032], [-79.75, -1.6], [-80.927, -2.256]], // Manta - Salinas

				[[-85.522, -2.666], [-82.164, -2.559], [-80.927, -2.256]],
				[[-82.164, -2.559], [-81, -3.1], [-81.045, -4.103]],

				// las Toninas  - Santos - Fortaleza
				[[-46.291, -23.96], [-47.3, -33.5], [-56.706, -36.488]],
				[[-38.522, -3.73], [-34.137, -4.344], [-31.014, -10.221], [-38.727, -23.396], [-46.291, -23.96]],
				[[-38.727, -23.396], [-43.209, -22.911]],
				[[-31.014, -10.221], [-38.502, -12.977]],

				// Boca ratón - San Juan 
				[[-80.083, 26.359], [-71.589, 24.375], [-66.413, 18.221]],
				// San Juan - Tortola
				[[-66.413, 18.221], [-65.5, 18.6], [-64.639, 18.421]],
				// Tortola- Fortaleza - Barranquilla 
				[[-64.639, 18.421], [-49.831, 10.462], [-38.521, -3.73]],
				[[-66.413, 18.221], [-68.9, 17.1], [-74.017, 12.977], [-74.808, 11.012]],
				[[-68.9, 17.1], [-68.3, 18], [-68.423, 18.563]],


				////////////////////////// EXTRA TRANSANDINO

				[[-56.706, -36.488], [-58.437, -34.608]],
				// Valparaiso - Santiago
				[[-71.62, -33.046], [-70.65, -33.4]],
				[[-70.65, -33.438], [-70.8, -33], [-71.62, -33.046]],
				[[-71.62, -33.046], [-71.45, -33.6], [-70.65, -33.438]],
				// Valparaiso - Mendoza
				[[-71.62, -33.046], [-70, -32.8], [-68.846, -32.889]],
				// Santiago - Mendoza
				[[-70.65, -33.438], [-69.6, -33.6], [-68.846, -32.889]],
				// Mendoza - Buenos Aires
				[[-68.846, -32.889], [-63.437, -35.808], [-58.437, -34.608]],
				// Mendoza - Buenos Aires
				[[-68.846, -32.889], [-63.437, -31.808], [-58.437, -34.608]],
				//Buenos Aires - Toninas
				[[-58.437, -34.608], [-58.1, -35.5], [-56.705, -36.488]],

				//Santos - Sao Paolo
				[[-46.291, -23.961], [-47.3, -22.3], [-49.023, -21.955]],
				[[-46.291, -23.961], [-47.9, -23.6], [-49.023, -21.955]],

				//Sao Paolo - Rio de Janeiro
				[[-49.023, -21.955], [-46.4, -21.5], [-43.209, -22.911]],

				////////////////////////// EXTRA TRANSGUATELMATECO

				// Panama - San Jose - Managua - San Salvador - Guatemala
				[[-79.534, 8.971], [-82, 8.5], [-84.077, 9.913], [-86.274, 12.146], [-89.191, 13.699], [-90.513, 14.642]],

				//  San Jose  -  Guatemala
				[[-84.077, 9.913], [-86, 14.146], [-90.513, 14.642]]
			]
		},
		name: 'SAM-1',
		codename: 'SAM-1',
		long: 25000,
		lon: -68,
		lat: -5,
		zoom: 1.5,
		ls: [3, 4, 5, 8, 9, 10, 11, 12, 15, 16, 17, 18, 24, 25, 36, 37, 38, 47, 48, 49, 54, 78]
	},

	// PCCS
	{
		geometry: {
			type: 'MultiLineString',
			coordinates: [
				// Jacksonville - Tortola
				[[-81.4, 30.332], [-68, 24], [-64.639, 18.421]],
				// Tortola - Maria Chiquita
				[[-64.639, 18.421], [-75, 14.5], [-79.753, 9.441]],
				[[-79.534, 8.971], [-79.753, 9.441]],
				[[-79.534, 8.971], [-81.734, 3.667], [-80.822, -1.0321]],
				// Aruba, Curaçao
				[[-72.1, 15.95], [-69.961, 12.49], [-68.964, 12.18]],
				// Cartagena
				[[-75.5, 9.5], [-77.45, 12.55]],
				// Tortola - San Juan
				[[-64.639, 18.421], [-66.413, 18.221]]
			]
		},
		name: 'PCCS',
		codename: 'PCCS',
		long: 6000,
		lon: -73,
		lat: 14,
		zoom: 3,
		ls: [20, 24, 42, 43, 46, 54, 71, 74, 89]
	},

	// UNISUR
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-56.705074, -36.488249], [-55.4, -35.9], [-54.9, -34.5]]
		},

		name: 'UNISUR',
		codename: 'UNISUR',
		long: 265,
		lon: -55.74,
		lat: -35.55,
		zoom: 6,
		ls: [5]
	},

	// EST-TET
	{
		geometry: {
			type: 'LineString',
			coordinates: [[-5.147, 36.427], [-5.365, 35.574]]
		},
		name: 'EST-TET',
		codename: 'EST-TET',
		long: 113,
		lon: -3,
		lat: 36,
		zoom: 16,
		ls: [59]
	},

	// ALPAL-2
	{
		geometry: {
			type: 'LineString',
			coordinates: [[2.97, 39.355], [2.9, 36.8]]
		},
		name: 'ALPAL-2',
		codename: 'ALPAL-2',
		long: 312,
		lon: 3,
		lat: 38.1,
		zoom: 10,
		ls: [61]
	},

	// DUNANT
	{
		geometry: {
			type: 'MultiLineString',
			coordinates: [
				[[-1.975, 46.726], [-15.66, 47.56], [-30.41, 44.16], [-54.32, 39.71], [-75.977, 36.853]]
			]
		},
		name: 'DUNANT',
		codename: 'DUNANT',
		long: 6600,
		lon: -50,
		lat: 12,
		zoom: 1.1,
		ls: [82, 91]
	},

	// JUNIOR
	{
		geometry: {
			type: 'MultiLineString',
			coordinates: [
				[[-43.209, -22.911], [-43.8, -24], [-45.45, -24.5], [-46.291, -23.961]]
			]
		},
		name: 'JUNIOR',
		codename: 'JUNIOR',
		long: 390,
		lon: -44,
		lat: -24,
		zoom: 10,
		ls: [11, 9]
	},

	// TANNAT
	{
		geometry: {
			type: 'MultiLineString',
			coordinates: [
				[[-46.291, -23.961], [-47, -28], [-48.5, -33.25], [-51.77, -35.53],[-56.705, -36.488]]				]
		},
		name: 'TANNAT',
		codename: 'TANNAT',
		long: 2000,
		lon: -50,
		lat: -30,
		zoom: 4,
		ls: [5, 11]
	},

	// NEW PACIFIC 
	{
		geometry: {
			type: 'MultiLineString',
			coordinates: [
				[[-90.834, 13.93], [-92, -0.2], [-88, -14], [-79, -22], [-71.62, -33.046]],
				[[-92, -0.2], [-86.5, -2], [-80.927, -2.256]],
				[[-88, -14], [-82, -14], [-76.878, -12.277]],
				[[-79, -22], [-75, -21], [-70.321, -18.479]]
			]
		},
		name: 'MISTRAL',
		codename: 'MISTRAL',
		long: 7300,
		lon: -78,
		lat: -12,
		zoom: 2,
		ls: [15, 17, 25, 37, 48]
	},

	// TIKAL
	{
		geometry: {
			type: 'MultiLineString',
			coordinates: [
				// Boca Raton - Pto Barrios, Guatemala -  Pto San Jose
				[
					[-80.083, 26.359],
					[-80.3, 24],
					[-85.5, 24],
					[-84.7, 20],
					[-88.435, 15.836]
				],
				[ [-84.77, 20.85], [-86.94, 21.17] ]
			]
		},
		name: 'TIKAL (In progress)',
		codename: 'TIKAL',
		long: 1000,
		lon: -83,
		lat: 20,
		zoom: 3,
		ls: [38, 78, 99]
	},
];

export default dataCables;
